import { createSlice } from "@reduxjs/toolkit";

import { getHealthAlerts, getHealthMetrics } from "./actions";

const initialState = {
  filters: {
    timePeriod: 1,
    period: 300,
    statistic: "Average",
  },
  load: false,
};

export const channelSummarySlice = createSlice({
  name: "channelSummary",
  initialState: initialState,
  reducers: {
    setTimePeriod: (state, action) => {
      state.filters.timePeriod = action?.payload;
    },
    setPeriod: (state, action) => {
      state.filters.period = action?.payload;
    },
    setStatistic: (state, action) => {
      state.filters.statistic = action?.payload;
    },
    setLoad: (state, action) => {
      state.load = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHealthMetrics.fulfilled, (state, action) => {
      if (action?.payload?.success) {
        state.graphData = action?.payload?.data;
      }
      state.load = false;
    });
    builder.addCase(getHealthAlerts.fulfilled, (state, action) => {
      if (action?.payload?.success) {
        state.alerts = action?.payload?.data;
        state.alertStatus = action?.payload?.alertStatus; // Consolidated this in one handler
      }
      state.load = false;
    });
  },
});

export const { setTimePeriod, setStatistic, setPeriod, setLoad } = channelSummarySlice.actions;

export default channelSummarySlice.reducer;
